import { useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

// jsdom and SSR have no matchMedia.
const media = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(QUERY)
    : null;

const subscribe = (onChange: () => void) => {
  const list = media();
  list?.addEventListener("change", onChange);
  return () => list?.removeEventListener("change", onChange);
};

/** The OS reduced-motion setting, for JS-driven motion the config can't reach. */
export const useReducedMotion = () =>
  useSyncExternalStore(
    subscribe,
    () => media()?.matches ?? false,
    () => false,
  );
